module.exports = __webpack_public_path__ + "img/11.234bd00c.jpg";